<template>
    <div class="row gx-2">
        <div class="col-md-4 py-lg-5 py-2"
             v-for="(service, index) in services" :key="index"
        >
            <a :href="service.link" class="item">
                <div class="image-wrap">
                    <v-lazy-image :src="'/storage/' + service.image"
                                  :alt="service.title"
                    ></v-lazy-image>
<!--                    <img :src="'/storage/' + site.image" :alt="site.name">-->
                </div>
                <h3>{{ service.title }}</h3>
                <p>{{ service.perex }}</p>
                <span class="link">
                    <span>Zobraziť viac</span>
                    <img src="/themes/default/img/icons/link.svg"
                         alt="link"
                         onload="SVGInject(this);"
                    >
                </span>
            </a>
        </div>
    </div>
</template>

<script>
    import VLazyImage from "v-lazy-image";

    export default {
        props: {

            services: {
                required: true,
                type: Array
            }
        },

        components: {
            VLazyImage
        }
    }
</script>
